import { useEffect, useRef } from 'react';
import { GalleryPurgeBatch, runGalleryYearPurgeOnce } from '../../utils/runGalleryYearPurge';

type Props = {
  purgeKey: string;
  requestBatch: () => Promise<GalleryPurgeBatch | undefined>;
  onPurged?: (count: number) => void;
  /** Trang admin hiện toast một lần khi xóa xong. Trang user thì không. */
  toast?: boolean;
};

/** Chạy một lần khi trang gallery được mở. */
const PurgeOldGalleries: React.FC<Props> = ({ purgeKey, requestBatch, onPurged, toast = false }) => {
  const onPurgedRef = useRef(onPurged);
  const requestRef = useRef(requestBatch);
  onPurgedRef.current = onPurged;
  requestRef.current = requestBatch;

  useEffect(() => {
    let active = true;
    runGalleryYearPurgeOnce(purgeKey, () => requestRef.current(), { toast })
      .then((count) => {
        if (active && count > 0) onPurgedRef.current?.(count);
      })
      .catch((err) => {
        console.warn('purge old galleries', err);
      });
    return () => {
      active = false;
    };
  }, [purgeKey, toast]);

  return null;
};

export default PurgeOldGalleries;
